import { api } from "../../lib/api";

export interface ClientSummary {
  id: string;
  email: string;
  full_name: string | null;
  phone: string | null;
  kyc_status: string;
  created_at: string;
}

export interface Position {
  security_id: string;
  ticker: string;
  name: string;
  quantity: string;
  cump: string;
  total_cost: string;
  realized_pnl: string;
  market_price: string | null;
  price_date: string | null;
  market_value: string | null;
  unrealized_pnl: string | null;
  unrealized_pnl_pct: string | null;
  day_change_value: string | null;
  annualized_return: string | null;
}

export interface PortfolioSummary {
  securities_value: string;
  invested_cost: string;
  unrealized_pnl: string;
  realized_pnl: string;
  day_change_value: string;
  cash_balance: string;
  total_value: string;
  total_return_pct: string | null;
  weighted_annualized_return: string | null;
}

export interface ClientPortfolio {
  id: string;
  name: string;
  baseCurrency: string;
  isDefault: boolean;
  /** `sgi` holds actions + obligations, `sgo` holds FCP only. */
  kind: "sgi" | "sgo";
  /** Target annual return, in percent — null only for legacy portfolios. */
  targetReturn: string | null;
  createdAt: string;
  summary: PortfolioSummary;
  positions: Position[];
}

export interface ClientDetail extends ClientSummary {
  portfolios: ClientPortfolio[];
}

export const searchClients = (q: string) =>
  api<{ data: ClientSummary[] }>(`/admin/clients?q=${encodeURIComponent(q)}`).then(
    (r) => r.data,
  );

export const getClientDetail = (id: string) =>
  api<{ client: ClientDetail }>(`/admin/clients/${id}`).then((r) => r.client);
